import { TFeatureFlags } from '../../../../store/modules/posthog/types'

export const getData = (flag: TFeatureFlags) => {
  const data = {
    menu_questions: {
      title: 'Falta muito pouco!',
      content:
        'Você está a poucos instantes de acessar o novo sistema de questões. Estamos organizando a liberação do acesso para melhorar sua experiência de estudos.',
    },
    default: {
      title: 'Falta muito pouco!',
      content:
        'Você está a poucos instantes de acessar essa nova funcionalidade. Estamos organizando a liberação do acesso para melhorar sua experiência de estudos.',
    },
  }

  return data[flag] || data.default
}
